import { isAffiliate, isStudent } from "../../../utils"
import {
  getCurrentLevel,
  getCurrentProgressLevelCode,
  getMostRecentCompletedLevel,
  parseNumberFromLevelCode,
} from "../../CourseCurriculum/CurriculumMessage/utils"
import { LEVEL } from "./constants/levels"

export const isPastQualifyingOnCourseCurriculum = me => {
  const { currentLevelKey, mostRecentCompletedLevelKey } = me?.pgmProgress || {}

  if (currentLevelKey && currentLevelKey !== LEVEL.QUALIFYING) {
    return true
  }

  if (
    mostRecentCompletedLevelKey &&
    mostRecentCompletedLevelKey !== LEVEL.QUALIFYING
  ) {
    return true
  }

  const progressLevelCode =
    getCurrentProgressLevelCode(me) ||
    getCurrentLevel(me) ||
    getMostRecentCompletedLevel(me)
  const levelNumber = parseNumberFromLevelCode(progressLevelCode)

  return levelNumber != null && levelNumber >= 1
}

export const shouldShowCourseCurriculumAdditionalRequirements = ({
  me,
  pgmGraduate = false,
  isMemberApplicationChecklistEnabled = false,
}) => {
  if (!isMemberApplicationChecklistEnabled || !me) {
    return false
  }

  // Member-apply checklist rows (credits, employment, dues) do not match
  // Affiliate → Associate gates. Keep Additional Requirements off Curriculum.
  if (isAffiliate(me)) {
    return false
  }

  if (isStudent(me)) {
    // Mid-program students past Qualifying, plus graduates still routed as students.
    return pgmGraduate === true || isPastQualifyingOnCourseCurriculum(me)
  }

  return isPastQualifyingOnCourseCurriculum(me)
}
